import { Container } from './styled';

export const Input = (props) => {

    const {
        id,
        icon,
        label,
        disable,
        className,
        ...rest
    } = props

    return (
        <Container disable={disable} className={className}>
            <input id={id} {...rest} />
            {label && <label htmlFor={id}>{label}</label>}
            {icon && <span>{icon}</span>}
        </Container>
    );

};
